var React = require('react');

function FormToggleArrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"form-toggle-arrow"),React.createElement("polygon",{"points":"22.43 0 11.21 11.21 0 0 22.43 0","key":1})]);
}

FormToggleArrow.defaultProps = {"width":"22.43","height":"11.22","viewBox":"0 0 22.43 11.22"};

module.exports = FormToggleArrow;

FormToggleArrow.default = FormToggleArrow;
